<template>
  <div class="h-60px flex justify-between items-center w-$portalContainerWidth mx-auto">
    <div class="pl-20px">
      <img
        class="h-30px cursor-pointer"
        :src="getLogo()"
        alt=""
        @click="$router.push(`${routerBase}/portal/homepage`)"
      />
    </div>
    <div class="flex items-center">
      <!-- <el-button class="mr-10px" size="small" @click="toBIM">数字工程</el-button>
      <el-button class="mr-10px" size="small" @click="toCockpit">智慧企业</el-button>
      <el-button class="mr-10px" size="small" @click="toAppCenter">应用中心</el-button>
      <el-button class="mr-10px" size="small" @click="toWorkBench" v-if="userInfo"
        >工作台</el-button
      > -->
      <template v-for="(item, index) in navigation">
        <div
          class="text-14px font-bold h-14px flex items-center"
          :key="index"
          v-if="item.url.startsWith('http') || userInfo"
        >
          <span class="mx-16px cursor-pointer" @click="jump(item)">{{ item.name }}</span>
          <span
            v-if="index !== navigation.length - 1"
            class="w-2px h-full bg-$portalPrimaryColor rounded-1px"
          ></span>
        </div>
      </template>

      <div v-if="!userInfo" class="mr-20px">
        <span
          class="w-2px h-full bg-$portalPrimaryColor rounded-1px inline-block h-14px mr-14px"
        ></span>
        <el-button type="primary" size="small" @click="toLogin"> 统一登录 </el-button>
      </div>
      <el-input
        class="w-180px focus:border-$portalPrimaryColor"
        placeholder="请输入关键字搜索"
        prefix-icon="el-icon-search"
        clearable
        v-model="keyWord"
        @input="search"
      >
      </el-input>
      <div
        class="relative mr-20px ml-20px"
        @click="$router.push(`${routerBase}/portal/workbench`)"
        v-if="userInfo"
      >
        <div
          class="bg-$portalPrimaryColor w-6px h-6px rounded-1/2 absolute right-0"
          v-if="haveTodo"
        ></div>
        <img
          class="cursor-pointer w-20px h-20px max-w-none"
          src="@/assets/images/消息中心.png"
          alt=""
        />
      </div>
      <img class="mr-3px h-28px w-28px rounded-1/2" :src="userPic" alt="" v-if="userInfo" />
      <el-dropdown class="overflow-visible" v-if="userInfo">
        <div class="flex items-center text-hex-333">
          <span class="el-dropdown-link inline-block max-w-55px truncate">
            {{ userInfo.profile.given_name }}
          </span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="1"
            @click.native="toBackground('/system-management/personal-center')"
            >个人中心</el-dropdown-item
          >
          <el-dropdown-item
            command="2"
            @click.native="
              toBackground('/portal-management/information-publish/column-publish-application')
            "
            >门户管理</el-dropdown-item
          >
          <el-dropdown-item command="3" @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { ColumnTableSearchApi } from '@wiz-api/workbench'

const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
const columnTableSearchApi = new ColumnTableSearchApi()
export default {
  name: 'portalHeader',
  components: {},
  props: {
    logo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      keyWord: '',
      navigation: config.navigation || [],
      userInfo: null,
      haveTodo: false,
    }
  },
  watch: {},
  methods: {
    search(value) {
      this.$router.push({
        path: `${this.routerBase}/portal/search`,
        query: {
          text: value,
        },
      })
    },
    toLogin() {
      // 退出登录还原默认icon title
      document.querySelector("link[rel='icon']").href = require('../image/favicon.png')
      document.title = 'Wiz Saas'
      if (window.__POWERED_BY_QIANKUN__) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: this.$route.fullPath,
          },
        })
      } else if (config?.fromDiyCode) {
        window.location.href = `${
          Wiz.globalSettings?.globalConfig?.diyCodePage
        }/#/login?returnUrl=${encodeURIComponent(window.location.href)}`
      } else {
        this.$router.push({
          path: Wiz.globalSettings?.auth?.defaultLoginPath,
          query: {
            returnUrl: this.$route.fullPath,
          },
        })
      }
    },
    jump(item) {
      let url = item.url
      // 变量替换
      if (item.url.indexOf('{token}') > -1) {
        // if (!this.userInfo) {
        //   this.toLogin()
        //   return
        // }
        url = item.url.replace('{token}', this.userInfo?.access_token)
      }
      // 当前项目模块
      if (item.url.startsWith(window.location.origin)) {
        if (!this.userInfo) {
          // 跳转登录再做重定向
          window.open(
            `${Wiz.globalSettings?.globalConfig?.diyCodePage}/#/login?returnUrl=${item.url.replace(
              window.location.origin,
              ''
            )}`
          )
          return
        }
      }
      if (item.url.startsWith('http')) {
        window.open(url)
      } else {
        this.$router.push(`${this.routerBase}${url}`)
      }
    },
    toBackground(path) {
      if (config?.fromDiyCode) {
        const routerBase = `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
        window.location.href = `${Wiz.globalSettings?.globalConfig?.diyCodePage}/#${routerBase}${path}`
      } else {
        this.$router.push(`${this.routerBase}${path}`)
      }
    },
    logout() {
      const currentTheme = this.$store.getters['System/currentTheme']
      const accountInfo = localStorage.getItem('accountInfo')
      localStorage.clear()
      const vuexModules = ['Auth', 'System', 'Abp', 'Sites']
      vuexModules.forEach((item) => {
        this.$store.commit(`${item}/resetState`)
      })
      // 退出清空缓存后设置当前主题缓存 保证登录页主题显示正常
      this.$store.dispatch('System/currentTheme', currentTheme)
      if (accountInfo) {
        localStorage.setItem('accountInfo', accountInfo)
      }
      this.userInfo = null
      this.$router.replace('/portal/homepage')
    },
    getLogo() {
      if (!this.logo) {
        return ''
      }
      return `${this.fileUrl}public/image/${this.logo}`
    },
    async getTodo() {
      const [err, res] = await columnTableSearchApi.getTodoColumnTable(1, 1, {
        title: '',
        isCompeleted: false,
      })
      if (!err) {
        this.haveTodo = res.items.length > 0
      }
    },
  },
  created() {},
  async mounted() {
    this.userInfo = Wiz.AuthHooks.GetUserInfo()
    if (this.userInfo) {
      this.getTodo()
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/`
    },
    AvatarUrl() {
      if (window.__POWERED_BY_QIANKUN__ || config?.fromDiyCode) {
        return _.get(Wiz, 'globalSettings.globalConfig.diyCodeMediaServer')
      }
      return this.fileUrl
    },
    userPic() {
      const avatar = this.userInfo?.profile?.avatar
      if (avatar) {
        return `${this.AvatarUrl}${avatar}`
      }
      const gender = this.userInfo?.profile?.gender || '1'
      return require(`../image/avatar${gender}.png`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
